export default function () {

	var DOC = document;

	var CORE = {

		className: 'category-bottom--desc',

		elements: null,

		more: {

			classNames: {
				main: 'category-bottom--desc__more',
				button: 'category-bottom--desc__more__button',
				icon: 'category-bottom--desc__more__icon',
				title: 'category-bottom--desc__more__title',
				open: 'category-bottom--desc--open'
			},

			elements: null,

			html: function () {
				var output = '';

				output += '<div class="' + CORE.more.classNames.main + '">';
				output += '<button class="' + CORE.more.classNames.button + '">';
				output += '<span class="' + CORE.more.classNames.icon + ' icon-arrow-l"></span>';
				output += '<span class="' + CORE.more.classNames.title + '">Voir plus</span>';
				output += '</button>'
				output += '</div>';

				return output;

			},

			onClick: function (e, el, holder, height) {

				var self = CORE.more;
				var $holder = $(holder);

				e.preventDefault();

				if ($holder.hasClass(self.classNames.open)) {
					$holder.removeClass(self.classNames.open);
					$holder.animate({ height: height + 'px' }, { queue: false, duration: 500 });
					$('.' + self.classNames.title, el).html('Voir plus');
					return;
				}
				$holder.addClass(self.classNames.open);
				$holder.animate({ height: holder.scrollHeight + 'px' }, { queue: false, duration: 500 });
				$('.' + self.classNames.title, el).html('Voir moins');
			},

			construct: function (desc, height) {
				var elements = desc.parentNode.getElementsByClassName(CORE.more.classNames.button);
				var i = 0;

				if (!elements || elements == null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
					return;
				}
				desc.style.height = height + 'px';
				CORE.more.elements = [];

				for (i; i < elements.length; i++) {
					CORE.more.elements[CORE.more.elements.length] = elements[i];
					elements[i].addEventListener('click', function (e) {
						CORE.more.onClick(e, this, desc, height);
					});
				}
			}

		},

		initialize: function (desc) {
			var occurence = null;
			var children = desc.childNodes;
			var i = 0;
			var count = 0;

			if (!children || children === null || typeof children !== 'object' || !('length' in children) || !children.length) {
				return;
			}

			for (i; i < children.length; i++) {
				if ( !('nodeName' in children[i]) || children[i].nodeName !== 'P') {
					continue;
				}

				if (count === 0) {
					occurence = children[i];
				}
				count++;
			}

			if (count > 1) {
				$(desc.parentNode).append(CORE.more.html());
				CORE.more.construct(desc, occurence.offsetHeight);
			}


		},

		construct: function () {
			var elements = DOC.getElementsByClassName(CORE.className);
			var i = 0;

			if (!elements || elements === null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
				return;
			}
			CORE.elements = [];

			for (i; i < elements.length; i++) {
				CORE.elements[CORE.elements.length] = elements[i];
				CORE.initialize(elements[i]);
			}

		}

	};
	CORE.construct();

};